<template>
  <div class="portrait">
    <div class="jc" style="padding:0 30px">
      <h4>受众画像</h4>    
      <el-radio-group class="tab clear" v-model="portraitName" @change="portraitTabClick">
        <el-radio-button label="观众画像">观众画像</el-radio-button>
        <el-radio-button label="粉丝画像">粉丝画像</el-radio-button>
      </el-radio-group>
    </div>

    <div class="audiencePortraitContainer clear">
      <div class="chart">
        <div class="chartTitle">
          <span>性别分布</span>
          <i>{{echartInfo.sexDistribution.name}}{{titleName||"-"}}数居多，占{{echartInfo.sexDistribution.value}}%</i>
        </div>
         <RingChart :ringChartInfo="sexDistributionData" ref="eChart1"></RingChart>
        <div class="sexType clear">
          <span>{{sexDistributionData.data[1].value}}%</span>
          <span>{{sexDistributionData.data[0].value}}%</span>
        </div>
      </div>
      <div class="chart">
        <div class="chartTitle">
          <span>年龄分布</span>
          <i>{{echartInfo.ageDistribution.name}}年龄阶段{{titleName||"-"}}居多，占{{echartInfo.ageDistribution.value}}%</i>
          <div class="mark_top">
            <span>城市占比</span>
            <span>TGI指数</span>
          </div>
        </div>
        <BarAndLineChart :barAndLineChartInfo="ageDistributionData" ref="eChart2"></BarAndLineChart>
      </div>
      <div class="chart">
        <div class="chartTitle">
          <span>设备分布</span>
          <i>{{echartInfo.equipmenDistribution.name}}手机{{titleName||"-"}}居多，占{{echartInfo.equipmenDistribution.value}}%</i>
        </div>
        <RingChart :ringChartInfo="equipmenDistributionData" ref="eChart5"></RingChart>
      </div>
      <div class="chart">
        <div class="chartTitle">
          <span>设备价格分布</span>
          <i>设备价格在{{echartInfo.equipmenDistributionPrice.name}}{{titleName||"-"}}居多，占{{echartInfo.equipmenDistributionPrice.value}}%</i>
        </div>
        <RingChart :ringChartInfo="equipmenDistributionPriceData" ref="eChart7"></RingChart>
      </div>
      <!-- <div class="chart">
        <div class="chartTitle">
          <span>粉丝活跃度</span>
          <i>{{echartInfo.activityPercen.value}}%粉丝最近{{echartInfo.activityPercen.name}}</i>
        </div>
        <RingChart :ringChartInfo="activityPercenData" ref="eChart8"></RingChart>
      </div> -->
      <div class="chart">
        <div class="chartTitle">
          <span>{{titleName||"-"}}活跃占比</span>
          <i>{{echartInfo.starActiveFansRateDtoList.name}} {{titleName||"-"}}最活跃，占比{{echartInfo.starActiveFansRateDtoList.value}}%</i>
        </div>
        <BarChart2 :barChart2Info="starActiveFansRateDtoList" ref="eChart12"></BarChart2>
      </div>
      <div class="chart">
        <div class="chartTitle">
          <span>{{titleName||"-"}}城市线分布</span>
          <i>{{echartInfo.cityPercen.name}}{{titleName||"-"}}居多，占{{echartInfo.cityPercen.value}}%</i>
          <div class="mark_top">
            <span>城市占比</span>
            <span>TGI指数</span>
          </div>
        </div>
        <BarAndLineChart :barAndLineChartInfo="cityPercenData" ref="eChart9"></BarAndLineChart>
      </div>
      <!-- <div class="chart chart2">
        <div class="chartTitle">
          <span>粉丝兴趣分布</span>
          <i>爱好{{echartInfo.fansInterest.name}}的粉丝居多，占比{{echartInfo.fansInterest.value}}%</i>
          <div class="mark_top">
            <span>城市占比</span>
            <span>TGI指数</span>
          </div>
        </div>
        <BarAndLineChart :barAndLineChartInfo="fansInterestData" ref="eChart10"></BarAndLineChart>
      </div> -->

      <div class="chart chart2">
        <div class="chartTitle">
          <span>{{titleName||"-"}}地域分布</span>
          <el-radio-group class="tab clear" v-model="fansAreaTab" @change="fansAreaChange">
            <el-radio-button label="省份">省份</el-radio-button>
            <el-radio-button label="城市">城市</el-radio-button>
          </el-radio-group>
          <i>{{echartInfo.cityDetailPercentage.name}}的{{titleName||"-"}}居多，占比{{echartInfo.cityDetailPercentage.value}}%</i>
          <div class="mark_top">
            <span>城市占比</span>
            <span>TGI指数</span>
          </div>
        </div>
        <BarAndLineChart :barAndLineChartInfo="cityDetailPercentageData" ref="eChart11"></BarAndLineChart>
      </div>
      <div class="chart chart2">
        <div class="chartTitle">
          <span>{{titleName||"-"}}九大人群占比</span>
          <i>{{echartInfo.nineMajorGroupsPercentage.name}} 的{{titleName||"-"}}占比居多，占比{{echartInfo.nineMajorGroupsPercentage.value}}%</i>
        </div>
        <BarChart2 :barChart2Info="nineMajorGroupsPercentage" ref="eChart12"></BarChart2>
      </div>

      <div class="chart chart2">
        <div class="chartTitle">
          <span>地域分布</span>
          <el-radio-group class="tab clear" v-model="areaTab" @change="areaChange">
            <el-radio-button label="占比">占比</el-radio-button>
            <el-radio-button label="渗透">渗透</el-radio-button>
          </el-radio-group>
        </div>
        <ChinaChart1 :chinaChartInfo="areaPercentageData" ref="eChart13"></ChinaChart1>
        <div class="chinaInfo">
          <div class="top">{{titleName||"-"}}数Top5省份</div>
          <span>Top1：{{areaTab==="占比"?echartInfo.areaPercentage[0].name:echartInfo.areaTopWithPermeation[0].name}}</span>
          <span>Top2：{{areaTab==="占比"?echartInfo.areaPercentage[1].name:echartInfo.areaTopWithPermeation[1].name}}</span>
          <span>Top3：{{areaTab==="占比"?echartInfo.areaPercentage[2].name:echartInfo.areaTopWithPermeation[2].name}}</span>
          <span>Top4：{{areaTab==="占比"?echartInfo.areaPercentage[3].name:echartInfo.areaTopWithPermeation[3].name}}</span>
          <span>Top5：{{areaTab==="占比"?echartInfo.areaPercentage[4].name:echartInfo.areaTopWithPermeation[4].name}}</span>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
  import RingChart from "../../../components/Echart/RingChart.vue";
  import BarChart2 from "../../../components/Echart/BarChart2.vue";
  import BarAndLineChart from "../../../components/Echart/BarAndLineChart.vue";
  import LineChart from "../../../components/Echart/LineChart.vue";
  import ChinaChart1 from "../../../components/Echart/ChinaChart1.vue";
  import tools from '../../../components/tools/tools';
  
  export default {
    name: "AudiencePortrait",
    props: [],
    data() {
      return {
        portraitName:"观众画像",
        titleName:"观众",
        //性别分布
        sexDistributionData:{
          nodeId:'sexDistribution',//节点
          data: [{value: 0, name: '女性'},{value: 0, name: '男性'},],//数据
          color:["#ff5c00","#40a0fc"],
          guideline:true,
          tooltipName:'粉丝总量',
          unit:'%'
        },
        //年龄分布
        ageDistributionData: {
          nodeId: "ageDistribution", //节点
          data: [], //数据
          data2: [], //数据
          color: ["#ff5c00", "#40a0fc"],
          xAxisData: [],
          yAxisName: "占比(%)",
          tooltipName: "",
          unit: "%",
          hideMarkLine:true,
        },
        //设备分布
        equipmenDistributionData: {
          nodeId: "equipmenDistribution",
          data: [{value: 0,name: "-"}],
          color: ["#2074ff","#38a1ff","#77bfff","#a7d6ff","#d0e9ff","#def0ff",],
          xAxisData: [],
          yAxisName: "占比",
          tooltipName: "",
          unit: "%",
          guideline: true, //引导线
        },
        // 设备价格分布
        equipmenDistributionPriceData: {
          nodeId: "equipmenDistributionPrice",
          data: [{value: 0,name: "-"}],
          color: ["#2074ff","#38a1ff","#77bfff","#a7d6ff","#d0e9ff","#def0ff",],
          xAxisData: [],
          yAxisName: "占比",
          tooltipName: "",
          unit: "%",
          guideline: true, //引导线
        },
        // 设备价格分布
        activityPercenData: {
          nodeId: "activityPercen",
          data: [{value: 0,name: "-"}],
          color: ["#2074ff","#38a1ff","#77bfff","#a7d6ff","#d0e9ff","#def0ff",],
          xAxisData: [],
          yAxisName: "占比",
          tooltipName: "",
          unit: "%",
          guideline: true, //引导线
        },
        // 粉丝城市线分布
        cityPercenData: {
          nodeId: "cityPercen",
          data: [], //数据
          data2: [], //数据
          color: ["#ff5c00", "#40a0fc"],
          xAxisData: [],
          yAxisName: "占比(%)",
          tooltipName: "",
          unit: "%",
          hideMarkLine:true,
        },
        // 粉丝兴趣分布
        fansInterestData: {
          nodeId: "fansInterestNode", //节点
          data: [], //数据
          data2: [], //数据
          color: ["#ff5c00", "#40a0fc"],
          xAxisData: [],
          yAxisName: "占比(%)",
          tooltipName: "",
          unit: "%",
        },
        // 粉丝城市分布
        cityDetailPercentageData:{
          nodeId: "cityPercentage", //节点
          data: [], //数据
          data2: [], //数据
          color: ["#ff5c00", "#40a0fc"],
          xAxisData: [],
          yAxisName: "占比(%)",
          tooltipName: "",
          unit: "%",
          hideMarkLine:true,
        },
        // 粉丝活跃占比
        starActiveFansRateDtoList:{
          nodeId: "starActiveFansRateDtoList", //节点
          data: [], //数据
          color: ["#ff5c00", "#40a0fc"],
          xAxisData: [],
          yAxisName: "占比(%)",
          tooltipName: "",
          unit: "%",
          hideMarkLine:true,
        },
        // 九大人群占比
        nineMajorGroupsPercentage:{
          nodeId: "nineMajorGroupsPercentage", //节点
          data: [], //数据
          color: ["#ff5c00", "#40a0fc"],
          xAxisData: [],
          yAxisName: "占比(%)",
          tooltipName: "",
          unit: "%",
          hideMarkLine:true,
        },
        // 地域分布
        areaPercentageData:{
          nodeId:'areaPercentage',//节点
          data: []//数据
        },
        areaTopWithPermeationData:{},
        areaTab:"占比",
        fansAreaTab:"省份",
        //图表说明
        echartInfo:{
          sexDistribution:{name:"-",value:"-"},
          ageDistribution:{name:"-",value:"-"},
          equipmenDistribution:{name:"-",value:"-"},
          equipmenDistributionPrice:{name:"-",value:"-"},
          activityPercen:{name:"-",value:"-"},
          cityPercen:{name:"-",value:"-"},
          fansInterest:{name:"-",value:"-"},
          cityDetailPercentage:{name:"-",value:"-"},
          starActiveFansRateDtoList:{name:"-",value:"-"},
          nineMajorGroupsPercentage:{name:"-",value:"-"},
          areaPercentage:[{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"}],
          areaTopWithPermeation:[{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"}]
        },
        darenInfo:{}
      };
    },
    computed: {},
    methods: {
      areaChange(val){
        this.areaTab = val
        if(val==="占比"){
          this.$refs.eChart13.chinaChart(this.areaPercentageData)
        }else if(val==="渗透"){
          this.$refs.eChart13.chinaChart(this.areaTopWithPermeationData)
        }
      },
      fansAreaChange(val){
        this.fansAreaTab = val
        // this.$nextTick(()=>{
        //   this.$refs.eChart11.barAndLineChart(this.cityDetailPercentageData)
        // })
        this.changChart()
      },
      portraitTabClick(tab){
        console.log('tab :>> ', tab);
        if(tab==="观众画像"){
          this.portraitName="观众画像"
          this.titleName="观众"
          this.darenInfo = JSON.parse(window.sessionStorage.getItem('getKsPortrait')).data.data.viewerPortrait
          this.changChart()
        }else if(tab==="粉丝画像"){
          this.portraitName="粉丝画像"
          this.titleName="粉丝"
          this.darenInfo = JSON.parse(window.sessionStorage.getItem('getKsPortrait')).data.data.fansPortrait
          this.changChart()
        }
        console.log('this.darenInfo :>> ', this.darenInfo);
        // this.changAllEchare()
      },
      changChart(){
        let echartInfo={
        sexDistribution:{name:"-",value:"-"},
        ageDistribution:{name:"-",value:"-"},
        equipmenDistribution:{name:"-",value:"-"},
        equipmenDistributionPrice:{name:"-",value:"-"},
        activityPercen:{name:"-",value:"-"},
        cityPercen:{name:"-",value:"-"},
        fansInterest:{name:"-",value:"-"},
        cityDetailPercentage:{name:"-",value:"-"},
        starActiveFansRateDtoList:{name:"-",value:"-"},
        nineMajorGroupsPercentage:{name:"-",value:"-"},
        areaPercentage:[{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"}],
        areaTopWithPermeation:[{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"},{name:"-",value:"-"}]
      }
      
      // 性别分布
      let sexDistributionData={
        nodeId:'sexDistribution',//节点
        data: [{value: 0, name: '女性'},{value: 0, name: '男性'},],//数据
        color:["#ff5c00","#40a0fc"],
        guideline:true,
        tooltipName:'粉丝总量',
        unit:'%'
      }
      sexDistributionData.data[0].value = tools.scale(this.darenInfo.sexPercentage[1].value,true)
      sexDistributionData.data[1].value = tools.scale(this.darenInfo.sexPercentage[0].value,true)
      this.sexDistributionData = sexDistributionData
      echartInfo.sexDistribution = sexDistributionData.data[tools.arraObjMax(sexDistributionData.data)]

      //年龄分布
      let ageDistributionData = {
        nodeId: "ageDistribution", //节点
        data: [], //数据
        data2:[],
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: ["23岁以下","24-30","31-40","41-50","50+"],
        yAxisName: "占比(%)",
        tooltipName: "年龄占比",
        unit: "%",
        hideMarkLine:true,
      }
      this.darenInfo.agePercentage.map(item=>{
        ageDistributionData.data.push(tools.scale(item.value,true))
        ageDistributionData.data2.push(item.tgi)
      })
      this.ageDistributionData = ageDistributionData
      echartInfo.ageDistribution.name = ageDistributionData.xAxisData[tools.arrayMax(ageDistributionData.data,"index")]
      echartInfo.ageDistribution.value = ageDistributionData.data[tools.arrayMax(ageDistributionData.data,"index")]

      //设备分布
      let equipmenDistributionData={
        nodeId: "equipmenDistribution",
        data: [],
        color: ["#ff5c00","#fa5f4b","#ffaa31","#59caf2","#16a0fd","#7384c6"],
        xAxisData: [],
        yAxisName: "占比",
        tooltipName: "年龄占比",
        unit: "%",
        guideline: true, //引导线
      }
      this.darenInfo.mobileBrandPercentage.map(item=>{
        equipmenDistributionData.data.push({value:tools.scale(item.value,true),name:item.label})
      })
      this.equipmenDistributionData = equipmenDistributionData
      echartInfo.equipmenDistribution = equipmenDistributionData.data[tools.arraObjMax(equipmenDistributionData.data)]

      // 设备价格分布
      let equipmenDistributionPriceData={
        nodeId: "equipmenDistributionPrice",
        data: [],
        color: ["#ff5c00","#fa5f4b","#ffaa31","#59caf2","#16a0fd","#7384c6"],
        xAxisData: [],
        yAxisName: "占比",
        tooltipName: "年龄占比",
        unit: "%",
        guideline: true, //引导线
      }
      this.darenInfo.mobilePricePercentage.map(item=>{
        equipmenDistributionPriceData.data.push({value:tools.scale(item.value,true),name:item.label})
      })
      this.equipmenDistributionPriceData = equipmenDistributionPriceData
      echartInfo.equipmenDistributionPrice = equipmenDistributionPriceData.data[tools.arraObjMax(equipmenDistributionPriceData.data)]

      // 粉丝活跃度
      let activityPercenData={
        nodeId: "activityPercen",
        data: [{value:0,name:'非常活跃'},{value:0,name:'一般活跃'}],
        color: ["#ff5c00","#fa5f4b","#ffaa31","#59caf2","#16a0fd","#7384c6"],
        xAxisData: [],
        yAxisName: "占比",
        tooltipName: "",
        unit: "%",
        guideline: true, //引导线
      }
      activityPercenData.data[0].value=tools.scale(this.darenInfo.activityPercentage[0].value,true)
      activityPercenData.data[1].value=tools.scale(this.darenInfo.activityPercentage[1].value,true)
      this.activityPercenData = activityPercenData
      echartInfo.activityPercen = activityPercenData.data[tools.arraObjMax(activityPercenData.data)]

      // 粉丝城市线分布
      let cityPercenData= {
        nodeId: "cityPercen",
        data: [], //数据
        data2: [], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: [],
        yAxisName: "占比(%)",
        tooltipName: "",
        unit: "%",
        hideMarkLine:true,
      }
      this.darenInfo.cityPercentage.map(item=>{
        if(item.label==="firstline"){
          item.label="一线"
        }else if(item.label==="secondline"){
          item.label="二线"
        }else if(item.label==="thirdline"){
          item.label="三线"
        }else if(item.label==="fourthline"){
          item.label="四线"
        }else if(item.label==="fifthline"){
          item.label="五线"
        }else if(item.label==="newfirstline"){
          item.label="新一线"
        }
        cityPercenData.xAxisData.push(item.label)
        cityPercenData.data.push(tools.scale(item.value,true))
        cityPercenData.data2.push(item.tgi)
      })
      this.cityPercenData = cityPercenData
      echartInfo.cityPercen.name = cityPercenData.xAxisData[tools.arrayMax(cityPercenData.data,"index")]
      echartInfo.cityPercen.value = cityPercenData.data[tools.arrayMax(cityPercenData.data,"index")]
      
      // 粉丝兴趣分布
      let fansInterestData={
        nodeId: "fansInterestNode", //节点
        data: [], //数据
        data2: [], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: [],
        yAxisName: "占比(%)",
        tooltipName: "",
        unit: "%",
      }
      this.darenInfo.interestPercentage.map(item=>{
        fansInterestData.xAxisData.push(item.label)
        fansInterestData.data.push(tools.scale(item.value,true))
        fansInterestData.data2.push(item.tgi)
      })
      this.fansInterestData = fansInterestData
      echartInfo.fansInterest.name = fansInterestData.xAxisData[tools.arrayMax(fansInterestData.data,"index")]
      echartInfo.fansInterest.value = fansInterestData.data[tools.arrayMax(fansInterestData.data,"index")]

      // 粉丝城市分布
      let cityDetailPercentageData = {
        nodeId: "cityDetailPercentage", //节点
        data: [], //数据
        data2: [], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: [],
        yAxisName: "占比(%)",
        tooltipName: "",
        unit: "%",
        hideMarkLine:true,
      }
      if(this.fansAreaTab=="城市"){
        this.darenInfo.cityLevelPercentage.map(item=>{
          cityDetailPercentageData.xAxisData.push(item.label)
          cityDetailPercentageData.data.push(tools.scale(item.value,true))
          cityDetailPercentageData.data2.push(item.tgi)
        })
        if(cityDetailPercentageData?.data?.length>10){
          cityDetailPercentageData.xAxisData = cityDetailPercentageData?.xAxisData?.slice(0,9)
          cityDetailPercentageData.data = cityDetailPercentageData?.data?.slice(0,9)
          cityDetailPercentageData.data2 = cityDetailPercentageData?.data2?.slice(0,9)
        }
        this.cityDetailPercentageData = cityDetailPercentageData
        echartInfo.cityDetailPercentage.name = cityDetailPercentageData.xAxisData[tools.arrayMax(cityDetailPercentageData.data,"index")]
        echartInfo.cityDetailPercentage.value = cityDetailPercentageData.data[tools.arrayMax(cityDetailPercentageData.data,"index")]
      }else if(this.fansAreaTab=="省份"){
        this.darenInfo.areaPercentage.map(item=>{
          cityDetailPercentageData.xAxisData.push(item.label)
          cityDetailPercentageData.data.push(tools.scale(item.value,true))
          cityDetailPercentageData.data2.push(item.tgi)
        })
        if(cityDetailPercentageData?.data?.length>10){
          cityDetailPercentageData.xAxisData = cityDetailPercentageData?.xAxisData?.slice(0,9)
          cityDetailPercentageData.data = cityDetailPercentageData?.data?.slice(0,9)
          cityDetailPercentageData.data2 = cityDetailPercentageData?.data2?.slice(0,9)
        }
        this.cityDetailPercentageData = cityDetailPercentageData
        echartInfo.cityDetailPercentage.name = cityDetailPercentageData.xAxisData[tools.arrayMax(cityDetailPercentageData.data,"index")]
        echartInfo.cityDetailPercentage.value = cityDetailPercentageData.data[tools.arrayMax(cityDetailPercentageData.data,"index")]
      }

      // 粉丝活跃占比
      let starActiveFansRateDtoList ={
        nodeId: "starActiveFansRateDtoList", //节点
        data: [], //数据
        smooth:true,
        xAxisData: [],
        yAxisName: "占比(%)",
        tooltipName: "",
        unit: '%',
        hideMarkLine:true,

      }
      this.darenInfo.activityPercentage.map(item=>{
        starActiveFansRateDtoList.xAxisData.push(item.label)
        starActiveFansRateDtoList.data.push(tools.scale(item.value,true))
      })
      this.starActiveFansRateDtoList = starActiveFansRateDtoList
      echartInfo.starActiveFansRateDtoList.name = starActiveFansRateDtoList.xAxisData[tools.arrayMax(starActiveFansRateDtoList.data,"index")]
      echartInfo.starActiveFansRateDtoList.value = starActiveFansRateDtoList.data[tools.arrayMax(starActiveFansRateDtoList.data,"index")]
      // 九大人群占比
      let nineMajorGroupsPercentage ={
        nodeId: "nineMajorGroupsPercentage", //节点
        data: [], //数据
        smooth:true,
        xAxisData: [],
        yAxisName: "占比(%)",
        tooltipName: "",
        unit: "%",
        hideMarkLine:true,
      }
      this.darenInfo.nineMajorGroupsPercentage.map(item=>{
        nineMajorGroupsPercentage.xAxisData.push(item.label)
        nineMajorGroupsPercentage.data.push(tools.scale(item.value,true))
      })
      this.nineMajorGroupsPercentage = nineMajorGroupsPercentage
      echartInfo.nineMajorGroupsPercentage.name = nineMajorGroupsPercentage.xAxisData[tools.arrayMax(nineMajorGroupsPercentage.data,"index")]
      echartInfo.nineMajorGroupsPercentage.value = nineMajorGroupsPercentage.data[tools.arrayMax(nineMajorGroupsPercentage.data,"index")]


      // 地域分布
      let areaPercentageData={
        nodeId:'areaPercentage',//节点
        data: [],//数据
        text:["高(%)","低(%)"]
      }
      this.darenInfo.areaPercentage.map(item=>{
        areaPercentageData.data.push({
          name:item.label,
          value:tools.scale(item.value,true)
        })
      })
      this.areaPercentageData = areaPercentageData
      let areadata2 = JSON.parse(JSON.stringify(areaPercentageData))
      echartInfo.areaPercentage[0] = areadata2.data[tools.arraObjMax(areadata2.data)]
      areadata2.data.splice(tools.arraObjMax(areadata2.data),1)
      echartInfo.areaPercentage[1] = areadata2.data[tools.arraObjMax(areadata2.data)]
      areadata2.data.splice(tools.arraObjMax(areadata2.data),1)
      echartInfo.areaPercentage[2] = areadata2.data[tools.arraObjMax(areadata2.data)]
      areadata2.data.splice(tools.arraObjMax(areadata2.data),1)
      echartInfo.areaPercentage[3] = areadata2.data[tools.arraObjMax(areadata2.data)]
      areadata2.data.splice(tools.arraObjMax(areadata2.data),1)
      echartInfo.areaPercentage[4] = areadata2.data[tools.arraObjMax(areadata2.data)]

      // 地域分布(渗透)
      let areaTopWithPermeationData={
        nodeId:'areaPercentage',//节点
        data: [],//数据
        text:["高(%)","低(%)"]
      }
      this.darenInfo.areaTopWithPermeation.map(item=>{
        areaTopWithPermeationData.data.push({
          name:item.label,
          value:tools.scale(item.value,true)
        })
      })
      this.areaTopWithPermeationData = areaTopWithPermeationData
      let areadata3 = JSON.parse(JSON.stringify(areaTopWithPermeationData))
      echartInfo.areaTopWithPermeation[0] = areadata3.data[tools.arraObjMax(areadata3.data)]
      areadata3.data.splice(tools.arraObjMax(areadata3.data),1)
      echartInfo.areaTopWithPermeation[1] = areadata3.data[tools.arraObjMax(areadata3.data)]
      areadata3.data.splice(tools.arraObjMax(areadata3.data),1)
      echartInfo.areaTopWithPermeation[2] = areadata3.data[tools.arraObjMax(areadata3.data)]
      areadata3.data.splice(tools.arraObjMax(areadata3.data),1)
      echartInfo.areaTopWithPermeation[3] = areadata3.data[tools.arraObjMax(areadata3.data)]
      areadata3.data.splice(tools.arraObjMax(areadata3.data),1)
      echartInfo.areaTopWithPermeation[4] = areadata3.data[tools.arraObjMax(areadata3.data)]



      this.echartInfo = echartInfo
      this.$refs?.eChart1?.ringChart(this.sexDistributionData)
      this.$refs?.eChart2?.barAndLineChart(this.ageDistributionData)
      this.$refs?.eChart5?.ringChart(this.equipmenDistributionData)
      this.$refs?.eChart7?.ringChart(this.equipmenDistributionPriceData)
      this.$refs?.eChart8?.ringChart(this.activityPercenData)
      this.$refs?.eChart9?.barAndLineChart(this.cityPercenData)
      this.$refs?.eChart10?.barAndLineChart(this.fansInterestData)
      this.$refs?.eChart11?.barAndLineChart(this.cityDetailPercentageData)
      this.$refs?.eChart12?.barChart2(this.starActiveFansRateDtoList)
      this.$refs?.eChart13?.chinaChart(this.areaPercentageData)
      this.$refs?.eChart14?.barChart2(this.nineMajorGroupsPercentage)
      }
    },
    components: {
      RingChart,
      BarChart2,
      LineChart,
      ChinaChart1,
      BarAndLineChart
    },
    watch: {},
    created(){
      let ksFans = JSON.parse(window.sessionStorage.getItem('getKsFans')).data.data
      // let darenInfo = JSON.parse(window.sessionStorage.getItem('getKsProfile')).data.data
      this.darenInfo = JSON.parse(window.sessionStorage.getItem('getKsPortrait')).data.data.viewerPortrait
      this.changChart()

    },
    mounted() {
      this.$refs?.eChart1?.ringChart(this.sexDistributionData)
      this.$refs?.eChart2?.barAndLineChart(this.ageDistributionData)
      this.$refs?.eChart5?.ringChart(this.equipmenDistributionData)
      this.$refs?.eChart7?.ringChart(this.equipmenDistributionPriceData)
      this.$refs?.eChart8?.ringChart(this.activityPercenData)
      this.$refs?.eChart9?.barAndLineChart(this.cityPercenData)
      this.$refs?.eChart10?.barAndLineChart(this.fansInterestData)
      this.$refs?.eChart11?.barAndLineChart(this.cityDetailPercentageData)
      this.$refs?.eChart12?.barChart2(this.starActiveFansRateDtoList)
      this.$refs?.eChart13?.chinaChart(this.areaPercentageData)
      this.$refs?.eChart14?.barChart2(this.nineMajorGroupsPercentage)
    },
  };
</script>

<style scoped>
 .flex{
   display: flex;
 }
 .jc{
  display: flex;
  justify-content: space-between;
  align-items: center;
 }
  .chart .mark_top{
    position: absolute;
    height: 20px;
    right: 20px;
    bottom: 0;
  }
  .chart .mark_top span{
    position: relative;
    line-height: 20px!important;
    margin-left: 30px;
    color:#666!important;
    font-size: 12px!important;
  }
  .chart .mark_top span::before{
    content: "";
    position: absolute;
    top:0;
    bottom: 0;
    left: -14px;
    margin: auto;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgb(57,154,253);
  }
  .chart .mark_top span:nth-of-type(2):before{
    background: #13deb9;
  }

  #areaPercentage{
    width: 100%;
    height: 320px;
    margin-top: -50px;
  }

  #nineMajorGroupsPercentage,
  #cityDetailPercentage,
  #cityPercentageData,
  #fansInterestNode {
    width: 100%;
    height: 280px;
  }
  #starActiveFansRateDtoList,
  #fansWatchDistribution,
  #equipmenDistribution,
  #equipmenDistributionPrice,
  #activityPercen,
  #cityPercen {
    margin-top: 10px;
    width: 100%;
    height: 210px;
  }

  #sexDistribution {
    margin-top: -20px;
    width: 100%;
    height: 210px;
  }

  #areaDistribution {
    margin-top: -4px;
    width: 100%;
    height: 230px;
  }
  #ageDistribution{
    margin-top: -4px;
    width: 110%;
    /* width: 100%; */
    height: 230px;
  }

  .chartChinaDes {
    position: absolute;
    bottom: 44px;
    left: 0px;
    width: 40px;
    height: 50px;
  }

  .chartChinaDes span {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 10px;
    height: 50px;
    background-image: linear-gradient(to bottom, #38a1ff, #e0f1ff);
  }

  .chartChinaDes i {
    position: absolute;
    top: -22px;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #5098d6;
    font-size: 12px;
    text-align: center;
  }

  .chartChinaDes i:nth-of-type(2) {
    top: auto;
    bottom: -22px;
  }

  .audiencePortraitContainer {
    /* margin-top: 15px; */
    padding: 0 30px;
    box-sizing: border-box;
  }

  .audiencePortraitContainer .chart {
    float: left;
    width: 50%;
    height: 360px;
    border-top: 1px solid #f0f0f0;
  }

  .audiencePortraitContainer .chart .chartTitle {
    display: block;
    position: relative;
    width: 100%;
    height: 104px;
  }

  .audiencePortraitContainer .chart .chartTitle span {
    line-height: 74px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
  }
  .audiencePortraitContainer .chart .chartTitle i {
    display: block;
    margin-top: -16px;
    font-size: 12px;
    font-weight: 500;
    color: #666;
  }

  .sexType span {
    position: relative;
    float: left;
    width: 50%;
    margin-top: 10px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #40a0fc;
    text-align: center;
  }

  .sexType span::before {
    position: absolute;
    top: -18px;
    content: "男性占比";
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }


  .sexType span::after {
    position: absolute;
    top: -12px;
    left: 40px;
    content: "";
    width: 30px;
    height: 30px;
    background: url("../images/boy.png") no-repeat center;
  }

  .sexType span:nth-of-type(2) {
    color: #ff5c00;
  }

  .sexType span:nth-of-type(2)::before {
    content: "女性占比";
  }
  .sexType span:nth-of-type(2)::after {
    background-image: url("../images/girl.png");
  }

  .chartTitle .tab {
    float: right;
    margin-top: 16px;
  }

  .portrait .summary{
    border-top: 1px solid #F0F0F0;
    width: 802px;
    margin-left: 30px;
    margin-top: 24px;
  } 
  .portrait .summary i{
    display: block;
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .portrait .summary span{
    margin-right: 36px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .portrait .summary span:nth-of-type(1){
    margin-left: 9px;
  }
  .audiencePortraitContainer .chart.chart2{
    width: 100%;
    height: 420px;
  }
  .chinaInfo{
    position: absolute;
    right: 60px;
    bottom: 70px;
    width: 100px;
  }
  .chinaInfo .top{
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #000;
    line-height: 17px;
    margin: 0 0 12px;
  }
  .chinaInfo span{
    display: block;
    margin: 0px 0px 4px;
    font-size: 12px;
    color: #666;
  }
</style>